import { createContext } from 'react'
const registerContext = createContext()
export default registerContext
